/**
 * 监测历史假数据（演示用）
 */

const SERIES_META = {
  水位: { unit: "m", base: 3.2, amp: 0.45, decimals: 2 },
  雨量: { unit: "mm", base: 1.5, amp: 4.5, decimals: 1 },
  积水: { unit: "m", base: 0.08, amp: 0.25, decimals: 2 },
  开度: { unit: "%", base: 35, amp: 40, decimals: 0 },
  压力: { unit: "MPa", base: 0.28, amp: 0.08, decimals: 3 },
  默认: { unit: "", base: 10, amp: 5, decimals: 1 },
};

/** 根据图层/字段推断曲线类型 */
export function resolveHistoryKind(fields = {}) {
  const layer = String(fields.图层 || "");
  const type = String(fields.类型 || "").toLowerCase();
  if (layer.includes("雨") || type === "yl" || fields.雨量 != null) return "雨量";
  if (layer.includes("积水") || type.includes("yjsd") || type === "jsjc") return "积水";
  if (layer.includes("工情") || type.includes("gq") || type.includes("zmkz")) return "开度";
  if (layer.includes("压力") || type.includes("gsgw") || type.includes("press"))
    return "压力";
  if (
    layer.includes("水情") ||
    layer.includes("水位") ||
    type === "hdsw" ||
    fields.水位 != null
  ) {
    return "水位";
  }
  if (layer.includes("泵") || layer.includes("二供")) return "压力";
  return null;
}

export function canShowHistory(fields = {}) {
  return !!resolveHistoryKind(fields);
}

function pad(n) {
  return String(n).padStart(2, "0");
}

function formatTime(d) {
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(
    d.getMinutes()
  )}`;
}

/**
 * 生成近 N 小时假时序
 * @returns {{ times: string[], values: number[], unit: string, kind: string }}
 */
export function buildMockHistory(fields = {}, hours = 48, stepMinutes = 60) {
  const kind = resolveHistoryKind(fields) || "默认";
  const meta = SERIES_META[kind] || SERIES_META.默认;
  const seed =
    String(fields.编码 || fields.名称 || "x")
      .split("")
      .reduce((s, c) => s + c.charCodeAt(0), 0) || 1;

  const times = [];
  const values = [];
  const now = Date.now();
  const steps = Math.floor((hours * 60) / stepMinutes);
  let v = meta.base + ((seed % 17) - 8) * 0.02;

  for (let i = steps; i >= 0; i--) {
    const t = new Date(now - i * stepMinutes * 60 * 1000);
    times.push(formatTime(t));
    // 伪随机游走 + 日周期
    const phase = (i / steps) * Math.PI * 4 + seed * 0.1;
    const noise = Math.sin(phase) * meta.amp * 0.35;
    const walk = (((seed * (i + 3)) % 100) / 100 - 0.5) * meta.amp * 0.25;
    v = Math.max(0, meta.base + noise + walk);
    values.push(Number(v.toFixed(meta.decimals)));
  }

  return { times, values, unit: meta.unit, kind };
}
